import classNames from 'classnames'
import React from 'react'

import { HStack } from '~/components/elements/HStack'
import { VStack } from '~/components/elements/VStack'

import styles from './ChartContainer.css'

export type ChartContainerProps = React.PropsWithChildren<{
  className?: string
  'data-testid'?: string
  header?: React.ReactNode
  id?: string
}>

export const ChartContainer = ({
  children,
  className,
  'data-testid': dataTestId = 'components-features-chart-container',
  header,
  id,
}: ChartContainerProps) => (
  <VStack
    className={classNames(styles.root, className)}
    data-testid={dataTestId}
    id={id}
    spacing={1}
  >
    <HStack justify="end" spacing={2}>
      {header}
    </HStack>

    {children}
  </VStack>
)
